import React from 'react';
import { Spinner } from 'react-bootstrap';

import useDecompSecaoParams from 'hooks/Relatorios/Decomp/useDecompSecaoParams';
import { useGetDecompEmpilhamentoQuery } from 'services/api/products/relatorios';
import Chart from './Chart';

export default function EmpilhamentoCustos() {
  const params = useDecompSecaoParams();

  const { data, isLoading } = useGetDecompEmpilhamentoQuery(params);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center p-3">
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  if (!data) {
    return null;
  }

  return (
    <div>
      <h5 className="mb-3">{data.titulo}</h5>
      <Chart data={data} />
    </div>
  );
}
